import * as React from 'react';
import { Query } from 'react-apollo';

import type { DescriptionPage_MarketingSource as MarketingSource } from '__generated__/graphql-types';

import { useLocation, useParams } from 'js/lib/useRouter';

import ConsumerBffSpecializationContext from 'bundles/unified-description-page-common/contexts/consumer/ConsumerBffSpecializationContext';
import ConsumerSpecializationMarketingPageQuery from 'bundles/unified-description-page-common/queries/bff/ConsumerSpecializationMarketingPageQuery.graphql';
import type {
  ConsumerSpecializationMarketingPageQuery as ConsumerSpecializationMarketingPageQueryType,
  ConsumerSpecializationMarketingPageQueryVariables,
} from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerSpecializationMarketingPageQuery';

type Props = {
  marketingSource: MarketingSource;
  children: React.ReactNode;
};

const ConsumerBffSpecializationMarketingDataProvider = ({ children, marketingSource }: Props) => {
  const { productSlug } = useParams();
  const { query } = useLocation();

  return (
    <Query<ConsumerSpecializationMarketingPageQueryType, ConsumerSpecializationMarketingPageQueryVariables>
      query={ConsumerSpecializationMarketingPageQuery}
      variables={{ slug: productSlug, marketingSource, isPreviewContentfulEntries: query?.preview === 'true' }}
      context={{ clientName: 'gatewayGql' }}
      errorPolicy="all"
    >
      {({ data, loading, error }) => {
        const specializationPageData = data?.DescriptionPage?.querySpecializationMarketingPage;

        return (
          <ConsumerBffSpecializationContext.Provider
            value={{ specializationPage: specializationPageData, isS12nDataLoading: loading, error }}
          >
            {children}
          </ConsumerBffSpecializationContext.Provider>
        );
      }}
    </Query>
  );
};

export default ConsumerBffSpecializationMarketingDataProvider;
